module.exports = "/images/london-23.jpg";